import { Form } from '@moneyforward/ap-frontend-components';

import { OptionCode } from '@/features/transaction_items/Detail/components/Drawer/Form/OptionCode';
import { OptionLabel } from '@/features/transaction_items/Detail/components/Drawer/Form/OptionLabel';
import { OptionPriority } from '@/features/transaction_items/Detail/components/Drawer/Form/OptionPriority';
import { OptionVisible } from '@/features/transaction_items/Detail/components/Drawer/Form/OptionVisible';
import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import classNames from 'classnames';
import { FC, memo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  methods: UseFormReturn<TransactionDetailOptionFormType>;
  onSubmit: (data: TransactionDetailOptionFormType) => void;
};

export const TransactionDetailOptionForm: FC<Props> = memo(
  ({ methods, onSubmit }) => {
    const { control } = methods;

    return (
      <Form<TransactionDetailOptionFormType>
        formMethod={methods}
        onSubmit={onSubmit}
        id='transaction_detail_option_form'
      >
        <div className={cx(styles['container'])}>
          <OptionCode control={control} />
          <OptionLabel control={control} />
          <OptionPriority control={control} />
          <OptionVisible control={control} />
        </div>
      </Form>
    );
  }
);
TransactionDetailOptionForm.displayName = 'TransactionDetailOptionForm';
